export default function VideoEmbed({ id, title, className = "", testId }) {
  return (
    <div
      data-testid={testId}
      className={`relative w-full aspect-video bg-[var(--tsws-green)] border-2 border-[var(--tsws-green)] ${className}`}
    >
      <iframe
        className="absolute inset-0 w-full h-full"
        src={`https://www.youtube.com/embed/${id}?rel=0&modestbranding=1`}
        title={title || "The Sesh With Sav"}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
}
